import React from "react";

const Advertistement = () => {
  return (
    <div className="advertistement">
      <h1> Advertistement</h1>
    </div>
  );
};

export default Advertistement;
